import { handleUserLoginReq } from "../../redux/user-slices/auth.slice";
import FacebookLogin from "../../components/ui/FacebookLogin";
import SkeletonImage from "../../components/ui/SkeletonImage";
import GoogleLogin from "../../components/ui/GoogleLogin";
import InputFieldA from "../../components/ui/InputFieldA";
import { useDispatch, useSelector } from "react-redux";
import { loginSchema } from "../../utils/velidations";
import { Link as NavLink, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Images from "../../assets/js/Images";
import { useState } from "react";

import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid2 as Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { handleCreateSubscriptionCheckout } from "../../redux/member-slices/payment.slice";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [helperText, setHelperText] = useState([]);
  const { loadings } = useSelector((state) => state.authSlice);

  // Handle user signup
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    const result = loginSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    await dispatch(
      handleUserLoginReq(formData)
    );
  };

  return (
    <Box sx={{ py: 3 }}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid size={{ xs: 12, md: 6, lg: 5 }} sx={{ alignSelf: "stretch" }}>
            <SkeletonImage src={Images?.login} sx={{ objectFit: "contain" }} />
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 5 }}>
            <Paper
              sx={{
                p: 3,
                border: "1px solid #f0f0f0",
              }}
              component="form"
              onSubmit={handleSubmit}
            >
              <Typography
                mb={3}
                fontSize={18}
                color="other.color1"
                fontWeight="500"
              >
                Login InnerPal
              </Typography>

              <Stack spacing={3}>
                <InputFieldA
                  name="email"
                  type="email"
                  label="Email"
                  helperText={helperText}
                />
                <InputFieldA
                  name="password"
                  type="password"
                  label="Enter Password"
                  helperText={helperText}
                />
                <Box>
                  <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_KEY} />
                  {helperText?.["g-recaptcha-response"] && (
                    <Typography mt={0.5} fontSize="14px" color="error.main">
                      {helperText?.["g-recaptcha-response"]}
                    </Typography>
                  )}
                  <Typography
                    mb={3}
                    fontSize={14}
                    color="other.color1"
                    textAlign="end"
                  >
                    <Link
                      sx={{ mb: "20px" }}
                      underline="hover"
                      component={NavLink}
                      to="/forgot-password"
                    >
                      Forgot password?
                    </Link>
                  </Typography>
                </Box>
                <Button
                  sx={{
                    p: "9px 17px",
                    lineHeight: "1.5",
                    fontSize: "18px",
                    justifyContent: "center",
                  }}
                  type="submit"
                  variant="contained"
                  endIcon={
                    loadings?.login && (
                      <CircularProgress size={22} color="text" thickness={6} />
                    )
                  }
                >
                  Login
                </Button>
                <Divider>
                  <Typography sx={{ color: "#d4d4d4" }} component="span">
                    Or
                  </Typography>
                </Divider>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FacebookLogin />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <GoogleLogin />
                  </Grid>
                </Grid>
                <Typography
                  mb={3}
                  fontSize={14}
                  color="other.color1"
                  textAlign="center"
                >
                  Don't have an account?
                  <Link
                    to="/register"
                    underline="hover"
                    sx={{ mb: "20px" }}
                    component={NavLink}
                  >
                    {" "}
                    Register
                  </Link>
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Login;
